/* eslint-disable react/no-array-index-key */
import { ReactNode } from 'react';

import { useFormContext } from 'libs/form/useFormContext';
import { Input } from 'libs/ui';
import { StackProps } from 'libs/ui/Stack/types';
import { OrderSection as BaseOrderSection } from 'modules/order/common/components';

export interface SectionProps {
  title: string;
  fields: (
    | {
        label: string;
        value: string | number | undefined;
        className?: string;
      }
    | JSX.Element
  )[];

  afterFields?: ReactNode;
  spacing?: StackProps['spacing'];
}

export const OrderSection = ({
  title,
  afterFields,
  fields,
  spacing,
}: SectionProps) => {
  const { readOnly } = useFormContext();
  const disabled = !readOnly;
  return (
    <BaseOrderSection
      afterFields={afterFields}
      fields={fields.map((field, index) => {
        if (typeof field === 'object' && 'value' in field) {
          return (
            <Input
              key={index.toString()}
              fullWidth
              readOnly
              showCopyButton
              className={field.className}
              disabled={disabled}
              label={field.label}
              value={field.value}
            />
          );
        }
        return field;
      })}
      spacing={spacing}
      title={title}
    />
  );
};
